<template>
    <button class="btn btn_s btn_white color_filter" @click="action_SelectCode" :class="{'off': !isSelected}">
        <div class="color_circle" :style="style"></div>
        {{ title }}
    </button>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import { sheetState } from '../../../../../../sheet-state'
import { workerState, workCodesUpdate } from '../../../worker-state'

export default {
    props: {
        code: Object
    },
    data() {
        return {
            sheetState,
            worker: workerState,
        }
    },
    computed: {
        reservationSetting: function() { return this.sheetState.reservationSetting },
        colorPalette: function() { return this.reservationSetting.workCodeColorPaletteID.basicPalette },
        hasCustomColor: function() { return this.code.usingCustomColor },
        customColorCode: function() { return this.code?.customColorCode },
        palette: function() { return this.reservationSetting?.workCodeColorPaletteID?.basicPalette },
        paletteIndex: function() { return this.code.paletteIndex },
        hexString: function() {
            if (this.hasCustomColor == true) { return this.customColorCode }
            return this.palette[this.paletteIndex]
        },
        title: function() { return this.code?.title },
        style: function() { return 'background-color: ' + this.hexString + ';'},
        isSelected: function() { return this.code.isSelected }
    },
    methods: {
        action_SelectCode() {
            let code = deepCopy(this.code)
            code.isSelected = !code.isSelected
            // if (code.isSelected == false) {
                this.worker.oldWorkCodeRecords = deepCopy(this.worker.modifiedRecords)
            // }
            workCodesUpdate([code])
        },
    }
}
</script>